// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"460":"b8dc7d2a","738":"734966e7"}[chunkId] + ".js";
};